export const API_ENDPOINT = 'https://www.catchit.sa/Catchit-Backend';
